import React from "react";
import Logo from "../../assets/img/wireguard-logo.png";

const Header = () => {
  return (
    <div className="flex space-x-1 sm:space-x-2 items-center my-6">
      <img src={Logo} alt="wireguard logo" className="size-6 sm:size-8 md:size-10" />
      <div className="text-xl sm:text-3xl md:text-4xl font-bold text-outer-space">Wire Watch</div>
    </div>
  );
};

export default Header;
